import ReportsList from '../reports/ReportsList';
const AccountantReportsList = () => <ReportsList />;
export default AccountantReportsList; 